export default __webpack_public_path__ + "6f784cf5073efd2b27adf5f8674b3051.png";